import { GenerationMethod } from '@heidi/schema/ml-scribe';
import { useCallback } from 'react';

import { type LegacyStreamResponseInput } from './legacy/_stream-response';

type UseAskAICommandTextParams = {
  sessionId: string;
  voiceStyle?: LegacyStreamResponseInput['voiceStyle'];
  brain?: LegacyStreamResponseInput['brain'];
  isCreatingForContextOnlySession?: boolean;
  /** Never stream to a session with no backend connection. */
  isOfflineLocalSession?: boolean;
  /** Injected so this stays store-free — dispatch or a plain function both satisfy it. */
  streamResponse: (payload: LegacyStreamResponseInput) => void;
};

/**
 * Core "free text typed -> generate" call shared by every picker that offers
 * an ask-Heidi free-text option, so the request shape lives in one place.
 */
export const useAskAICommandText = ({
  sessionId,
  voiceStyle,
  brain,
  isCreatingForContextOnlySession,
  isOfflineLocalSession,
  streamResponse,
}: UseAskAICommandTextParams) =>
  useCallback(
    (aiCommandText: string) => {
      if (isOfflineLocalSession) {
        return;
      }
      streamResponse({
        sessionID: sessionId,
        generationMethod: GenerationMethod.AI_COMMAND_TEXT,
        aiCommandText,
        voiceStyle,
        brain,
        isCreatingForContextOnlySession,
      });
    },
    [
      sessionId,
      voiceStyle,
      brain,
      isCreatingForContextOnlySession,
      isOfflineLocalSession,
      streamResponse,
    ]
  );
